import styled from 'styled-components';

const OurColleagues = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    width: 100%;
    height: 450px;
    gap: 30px;
    padding: 30px;
    margin-top: 50px;
    
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      margin-top: 100px;
      height: 750px;
      padding: 0;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        font-weight: 600;
        font-size: 2.3rem;
        letter-spacing: -1px;
        opacity: 0.7;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 2rem;
          text-align: center;
        }
      }
      p {
        line-height: 1.9;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }
    }
  }
`;
const OurMission = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    width: 100%;
    height: 400px;
    gap: 30px;
    padding: 30px;
    margin-top: 50px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      height: 650px;
      padding: 0;
      margin-top: 120px;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        font-weight: 600;
        font-size: 2.3rem;
        letter-spacing: -1px;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 2rem;
          text-align: center;
        }
      }
      p {
        line-height: 1.9;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }
    }
  }
`;
const WhyChooseRade = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    width: 100%;
    height: 400px;
    gap: 30px;
    padding: 30px;
    margin-top: 50px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      height: 480px;
      padding: 0;
      margin-top: 90px;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        font-weight: 600;
        font-size: 2.3rem;
        letter-spacing: -1px;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 2rem;
          text-align: center;
        }
      }
      p {
        line-height: 1.7;
        font-size: 1.1rem;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }
    }
  }
`;

export { OurColleagues, OurMission, WhyChooseRade };
